import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PhoneIcon = (props: IconProps) => (
  <Icon width="12px" height="12px" viewBox="0 0 12 12" {...props}>
    <path d="M2.413 5.693a10.1 10.1 0 0 0 4.394 4.394L8.273 8.62c.18-.18.447-.24.68-.16.747.247 1.554.38 2.38.38.367 0 .667.3.667.667v2.326c0 .367-.3.667-.667.667C5.073 12.5 0 7.427 0 1.167 0 .8.3.5.667.5H3c.367 0 .667.3.667.667 0 .833.133 1.633.38 2.38a.669.669 0 0 1-.167.68L2.413 5.693Z" />
  </Icon>
);

export default memo(PhoneIcon);
